// extracted by mini-css-extract-plugin
module.exports = {"cartTitle":"index-module__cartTitle___2u6sS"};